/**
 * Created by Mark on 10/04/2017.
 */



import React from "react";

import CDNImage from '../media/image.js';
import CDNAudio from '../../classes/audio.js';
import {Table}from 'react-bootstrap';
import Translation from '../../store/internationalization-store.js';
import Checkbox from '../checkbox.js';
class FormattedMessage extends React.Component {
    constructor(props) {
        super();
        this.props = props;
    }

    render(){
        return <span>{Translation.get(this.props.id , this.props.defaultMessage)}</span>
    }
}


export default class VocabTable extends React.Component {

    constructor(props){
        super();
        this.state = {
            vocab: props.vocab || [],
            selectedVocab: props.selectedVocab || {},
        }

    }

    componentWillReceiveProps(props){
        this.setState({vocab:props.vocab ||[]})
    }

    isSelected(vocabObj){
        return this.state.selectedVocab[vocabObj.uid];
    }

    handelVocabSelect(vocabObj){
        var selected = this.state.selectedVocab;

        if(this.isSelected(vocabObj))
        {
            delete selected[vocabObj.uid]
        }
        else
        {
            selected[vocabObj.uid] = vocabObj;
        }

        if(this.props.onSelect) this.props.onSelect(true , selected);
    }

    handelAudioClick(src){
        (new CDNAudio(src)).play();
    }

    componentWillReceiveProps(props){
        this.setState({vocab:props.vocab , selectedVocab:props.selectedVocab})
    }

    renderRow(){
        var items = [];

        for(var idx = 0; idx < this.state.vocab.length; idx++){

            let imageCol = <td width={110}><CDNImage size={90} isVocab src={this.state.vocab[idx].picture}></CDNImage></td>;

            if(sessionStorage.getItem("product") == "huber" || sessionStorage.getItem("product") == "klett" ||
                sessionStorage.getItem('product') == "larousse" || sessionStorage.getItem('product') == "hodder" ||
                sessionStorage.getItem('product') == "cornelson")
            {
                imageCol = "";
            }


            items.push(  <tr className={this.isSelected(this.state.vocab[idx]) ? "palette-Branding lightgreen bg animate-color p-0" : "animate-color p-0"}>
                {imageCol}
                <td>

                    {this.state.vocab[idx].word}
                </td>
                <td className="p-0" width={90}>
                    <center className="p-5">
                        <button onClick={this.handelAudioClick.bind(this ,  this.state.vocab[idx].learningAudio)} type="button" className="palette-White-Disabled bg m-r-30 small btn btn-icon command-edit waves-effect waves-circle" data-row-id="10248">
                            <CDNImage className="m-b-5" size={15} src="img/audioWordPod.png"/>
                        </button>
                    </center>
                </td>
                <td className="p-0" width={40}>
                    <center className="p-5">
                        <Checkbox checked={this.isSelected(this.state.vocab[idx])} onChange={this.handelVocabSelect.bind(this ,  this.state.vocab[idx])} />
                    </center>
                </td>
            </tr>)
        }

        return items;
    }

    render(){
        return (
            <Table condensed responsive bordered>
                <tbody>
                    {this.renderRow()}
                </tbody>
            </Table>
        );
    }
}